// src/context/FilterContext.jsx
import React, { createContext, useState, useEffect } from "react";
import { API_BASE_URL } from "../data_lib/apiConfig";

export const FilterContext = createContext();

export const FilterContextProvider = ({ children }) => {
  //estado para las tiendas
  const [stores, setStores] = useState([]);
  // estado para los ids de camaras
  const [cameras, setCameras] = useState([]);
  //estado para las edades
  const [ageRanges, setAgeRanges] = useState([]);
  //estado para manejar multiples opciones
  const [selectedStore, setSelectedStore] = useState("");
  const [selectedAgeRanges, setSelectedAgeRanges] = useState([]);

  // estado para manejar el objeto a buscar
  const [filtersObj, setfiltersObj] = useState({});

  // Inicialización de startDate al primer día del mes actual
  const [startDate, setStartDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  );
  // Inicialización de endDate al día actual
  const [endDate, setEndDate] = useState(new Date());

  // Estado para saber cuando buscar
  const [storeLoaded, setStoreLoaded] = useState(false);
  const [ageRangesLoaded, setAgeRangesLoaded] = useState(false);
  const [camerasLoaded, setCamerasLoaded] = useState(false);

  //useEffect para obtener las tiendas
  useEffect(() => {
    const fetchStores = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/stores/`);
        if (!response.ok) {
          throw new Error("Error en la petición");
        }
        const data = await response.json();
        setStores(data);
        setSelectedStore(data[data.length - 1].id); // ULTIMO ELEMENTO DE LAS TIENDAS
        // setSelectedStore(data[0].id); PRIMER ELEMENTO DE LAS TIENDAS
        setStoreLoaded(true);
      } catch (error) {
        console.error("error al obtener las tiendas", error);
      }
    };
    fetchStores();
  }, []);

  //useEffect para obtener las segmentaciones de edad
  useEffect(() => {
    const fetchAgeRanges = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/age_range/`);
        if (!response.ok) {
          throw new Error("Error en la petición");
        }
        let data = await response.json();
        data = data.sort((a, b) => a.from_age - b.from_age);
        setAgeRanges(data);
        setSelectedAgeRanges([data[0].range_name]);
        setAgeRangesLoaded(true);
      } catch (error) {
        console.error("error al obtener las tiendas", error);
      }
    };
    fetchAgeRanges();
  }, []);

  // useEffect para obtener los ids de las camaras
  useEffect(() => {
    if (selectedStore === "") return;
    const fetchCameras = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/cameras/store-cameras/${selectedStore}`
        );
        if (!response.ok) {
          throw new Error("Error en la petición");
        }
        const data = await response.json();
        setCameras(data);
        setCamerasLoaded(true);
      } catch (error) {
        console.error("error al obtener las camaras", error);
      }
    };
    fetchCameras();
  }, [selectedStore]);

  const contextValue = {
    stores,
    setStores,
    ageRanges,
    setAgeRanges,
    selectedStore,
    setSelectedStore,
    cameras,
    selectedAgeRanges,
    setSelectedAgeRanges,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    filtersObj,
    setfiltersObj,
    storeLoaded,
    ageRangesLoaded,
    camerasLoaded,
  };
  return (
    <FilterContext.Provider value={contextValue}>
      {children}
    </FilterContext.Provider>
  );
};
